<div class="general-information-v2-container">
    <div class="general-information-form container-fluid mt-4">
        <form [formGroup]="form">
            <div class="general-information-top-section">
                <div class="general-information-top-section-selections">
                    <!-- Company Selection -->
                    <div class="row company-section">
                        <div class="col-lg-auto">
                            <input
                                hamSimpleDropDown
                                [options]="companies"
                                [optionKeys]="['name']"
                                returnKey="_id"
                                [returnObject]="true"
                                [label]="'aumico_annual_report_general_information_company' | i18next"
                                [placeholder]="
                                    'aumico_annual_report_general_information_please_select_company' | i18next
                                "
                                [formControl]="form.controls['company']"
                                showRequired="true"
                            />
                            <div
                                *ngIf="form.controls['company'].touched && form.controls['company'].invalid"
                                class="warning"
                            >
                                <span *ngIf="form.controls['company'].errors?.['required']">
                                    {{ errors.MandatoryFieldError | i18next }}
                                </span>
                            </div>
                        </div>

                        <div class="col-lg-auto">
                            <input
                                hamSimpleDropDown
                                data-testid="gi-accounting-basis-select"
                                [options]="accountingBases"
                                [optionKeys]="['name']"
                                returnKey="id"
                                [returnObject]="true"
                                [label]="'aumico_annual_report_general_information_basis_of_accounting' | i18next"
                                [placeholder]="
                                    'aumico_annual_report_general_information_select_accounting_basis' | i18next
                                "
                                [formControl]="form.controls['accountingBasis']"
                                showRequired="true"
                            />
                            <div
                                *ngIf="
                                    form.controls['accountingBasis'].touched && form.controls['accountingBasis'].invalid
                                "
                                class="warning"
                            >
                                <span *ngIf="form.controls['accountingBasis'].errors?.['required']">
                                    {{ errors.MandatoryFieldError | i18next }}
                                </span>
                            </div>
                        </div>
                    </div>

                    <!-- AR Template and Language Section -->
                    <div class="row mt-3" *ngIf="showArTemplateDropdown">
                        <div class="col-lg-auto">
                            <input
                                hamSimpleDropDown
                                data-testid="gi-artemplate-select"
                                [options]="arTemplates"
                                [optionKeys]="['name']"
                                returnKey="id"
                                [returnObject]="true"
                                [label]="'aumico_annual_report_general_information_ar_template' | i18next"
                                [placeholder]="'aumico_annual_report_general_information_select_ar_template' | i18next"
                                [formControl]="form.controls['arTemplate']"
                                showRequired="true"
                            />
                            <div
                                *ngIf="form.controls['arTemplate'].touched && form.controls['arTemplate'].invalid"
                                class="warning"
                            >
                                <span *ngIf="form.controls['arTemplate'].errors?.['required']">
                                    {{ errors.MandatoryFieldError | i18next }}
                                </span>
                            </div>
                        </div>

                        <div class="col-lg-auto" *ngIf="showLanguageDropdown">
                            <input
                                hamSimpleDropDown
                                [options]="reportLanguages"
                                [optionKeys]="['name']"
                                returnKey="id"
                                [returnObject]="true"
                                [label]="'aumico_annual_report_general_information_report_language' | i18next"
                                [placeholder]="'aumico_annual_report_general_information_select_locale' | i18next"
                                [formControl]="form.controls['locale']"
                                showRequired="true"
                            />
                            <div
                                *ngIf="form.controls['locale'].touched && form.controls['locale'].invalid"
                                class="warning"
                            >
                                <span *ngIf="form.controls['locale'].errors?.['required']">
                                    {{ errors.MandatoryFieldError | i18next }}
                                </span>
                            </div>
                        </div>
                    </div>

                    <div class="row mt-3">
                        <div *ngIf="isCpmmActive" class="col-lg-auto">
                            <input
                                hamSimpleDropDown
                                [options]="reportTypes"
                                [optionKeys]="['name']"
                                returnKey="id"
                                [returnObject]="true"
                                [label]="'aumico_annual_report_general_information_report_type' | i18next"
                                [placeholder]="'aumico_annual_report_general_information_select_report_type' | i18next"
                                [formControl]="form.controls['reportType']"
                                showRequired="true"
                            />
                            <div
                                *ngIf="form.controls['reportType'].touched && form.controls['reportType'].invalid"
                                class="warning"
                            >
                                <span *ngIf="form.controls['reportType'].errors?.['required']">
                                    {{ errors.MandatoryFieldError | i18next }}
                                </span>
                            </div>
                        </div>

                        <div class="col-lg-auto">
                            <input
                                hamSimpleDropDown
                                [options]="currencies"
                                [optionKeys]="['name']"
                                returnKey="id"
                                [returnObject]="true"
                                [label]="
                                    (isFxReport
                                        ? 'aumico_annual_report_general_information_functional_currency'
                                        : 'aumico_annual_report_general_information_currency'
                                    ) | i18next
                                "
                                [placeholder]="
                                    'aumico_annual_report_general_information_please_determine_currency' | i18next
                                "
                                [formControl]="form.controls['currency']"
                                showRequired="true"
                            />
                            <div
                                *ngIf="form.controls['currency'].touched && form.controls['currency'].invalid"
                                class="warning"
                            >
                                <span *ngIf="form.controls['currency'].errors?.['required']">
                                    {{ errors.MandatoryFieldError | i18next }}
                                </span>
                            </div>
                        </div>
                    </div>

                    <div class="row mt-3" *ngIf="isFxReport">
                        <div class="col-lg-auto">
                            <input
                                hamSimpleDropDown
                                [options]="currencies"
                                [optionKeys]="['name']"
                                returnKey="id"
                                [returnObject]="true"
                                [label]="'aumico_annual_report_general_information_display_currency' | i18next"
                                [placeholder]="
                                    'aumico_annual_report_general_information_please_determine_display_currency'
                                        | i18next
                                "
                                [formControl]="form.controls['displayCurrency']"
                                showRequired="true"
                            />
                            <div
                                *ngIf="
                                    form.controls['displayCurrency'].touched &&
                                    form.controls['displayCurrency'].invalid
                                "
                                class="warning"
                            >
                                <span *ngIf="form.controls['displayCurrency'].errors?.['required']">
                                    {{ errors.MandatoryFieldError | i18next }}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Company Information Badge -->
                <div class="row mt-3" *ngIf="setupData?.company">
                    <div class="col-lg-auto">
                        <div class="company-info-badge">
                            <div class="company-avatar">
                                <div class="avatar-placeholder">
                                    <i class="fas fa-building" aria-hidden="true"></i>
                                </div>
                            </div>
                            <div class="company-details">
                                <div class="company-name">
                                    {{ setupData?.company.name || 'Company Name' }}
                                </div>
                                <div *ngIf="setupData?.company.label" class="company-name">
                                    {{ '(' + setupData?.company.label + ')' || '' }}
                                </div>
                                <div class="company-address">
                                    <div class="street" *ngIf="setupData?.company.street">
                                        {{ setupData?.company.street }}
                                    </div>
                                    <div class="city-zip" *ngIf="setupData?.company.zip || setupData?.company.city">
                                        <span *ngIf="setupData?.company.zip">{{ setupData?.company.zip }}</span>
                                        <span *ngIf="setupData?.company.city" [class.ml-1]="setupData?.company.zip">{{
                                            setupData?.company.city
                                        }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Dates Section -->
            <div class="mt-4">
                <div class="row border-top-separator"></div>

                <!-- Two Column Layout: Current Period and Previous Period -->
                <div class="dates-section row">
                    <!-- Current Period Column -->
                    <div class="col-md-6">
                        <div class="period-column current-period">
                            <div class="period-header current">
                                <h5 class="period-title">
                                    {{ 'aumico_general_information_current_period' | i18next }}
                                </h5>
                            </div>
                            <div class="period-column-content">
                                <!-- Balance Sheet Section -->
                                <div class="section-block balance-sheet-section">
                                    <div class="section-header">
                                        <h6 class="section-title">
                                            {{ 'aumico_general_information_balance_sheet' | i18next }}
                                        </h6>
                                    </div>

                                    <app-date-picker-flyout
                                        [formControl]="form.controls['balanceSheetDate']"
                                        [label]="'aumico_general_information_balance_sheet_date' | i18next"
                                        [required]="true"
                                        [showError]="true"
                                        [errorMessage]="errors.MandatoryFieldError | i18next"
                                        flyoutClass="balance-sheet-date-flyout"
                                        (dateSelected)="updateBalanceSheetDate($event)"
                                    ></app-date-picker-flyout>
                                </div>

                                <!-- Income Statement Section -->
                                <div class="section-block income-statement-section">
                                    <div class="section-header">
                                        <h6 class="section-title">
                                            {{ 'aumico_general_information_income_statement' | i18next }}
                                        </h6>
                                    </div>

                                    <app-date-picker-flyout
                                        [formControl]="form.controls['incomeCurrentYearFromDate']"
                                        [label]="'aumico_annual_report_general_information_date_from' | i18next"
                                        [required]="true"
                                        [showError]="true"
                                        [errorMessage]="errors.MandatoryFieldError | i18next"
                                        flyoutClass="income-current-from-date-flyout"
                                        (dateSelected)="updateIncomeCurrentFromDate($event)"
                                    ></app-date-picker-flyout>

                                    <app-date-picker-flyout
                                        [formControl]="form.controls['incomeCurrentYearToDate']"
                                        [label]="'aumico_annual_report_general_information_date_to' | i18next"
                                        [required]="true"
                                        [showError]="true"
                                        [errorMessage]="errors.MandatoryFieldError | i18next"
                                        flyoutClass="income-current-to-date-flyout"
                                        (dateSelected)="updateIncomeCurrentToDate($event)"
                                    ></app-date-picker-flyout>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Previous Period Column -->
                    <div class="col-md-6">
                        <div class="period-column previous-period">
                            <div class="period-header previous">
                                <h5 class="period-title">
                                    {{ 'aumico_general_information_previous_period' | i18next }}
                                </h5>
                                <!-- No Previous Data Toggle -->
                                <div class="row mb-4">
                                    <div data-testid="gi-has-previous-data-toggle" class="col">
                                        <ham-toggle
                                            [formControlValue]="form.controls['hasPreviousData']"
                                            hamTooltip="{{
                                                'aumico_annual_report_general_information_has_previous_data' | i18next
                                            }}"
                                            [disabled]="isSavedMode"
                                        >
                                        </ham-toggle>
                                    </div>
                                </div>
                            </div>
                            <div *ngIf="form.controls['hasPreviousData'].value" class="period-column-content">
                                <!-- Balance Sheet Section -->
                                <div class="section-block balance-sheet-section">
                                    <div class="section-header">
                                        <h6 class="section-title">
                                            {{ 'aumico_general_information_balance_sheet' | i18next }}
                                        </h6>
                                    </div>

                                    <app-date-picker-flyout
                                        [formControl]="form.controls['balancePreviousYearDate']"
                                        [label]="'aumico_general_information_balance_sheet_date' | i18next"
                                        [required]="true"
                                        [showError]="true"
                                        [errorMessage]="errors.MandatoryFieldError | i18next"
                                        [disabled]="disablePreviousSettings"
                                        flyoutClass="balance-previous-date-flyout"
                                        (dateSelected)="updateBalancePreviousDate($event)"
                                    ></app-date-picker-flyout>

                                    <!-- Toggle for Load previous period data from Aumico -->
                                    <div
                                        class="toggle-wrapper"
                                        data-testid="gi-autofill-balance-toggle"
                                        *ngIf="showAutofillFromPreviousForBalanceToggle"
                                    >
                                        <ham-toggle
                                            [formControlValue]="form.controls['autofillFromPreviousForBalance']"
                                            [disabled]="disablePreviousSettings"
                                        >
                                            {{ 'aumico_general_information_load_previous_data_from_aumico' | i18next }}
                                        </ham-toggle>
                                        <span
                                            class="ham-icon period-icon"
                                            hamTooltip="{{
                                                'aumico_general_information_choose_dataset_tooltip_text' | i18next
                                            }}"
                                            [withArrow]="true"
                                            [backGroundHexColor]="'#1F2A37'"
                                            [tooltipClass]="'cpmm-period'"
                                        >
                                            <i class="info-outline-icon"></i>
                                        </span>
                                    </div>

                                    <!-- Select Report Dropdown for Balance Sheet -->
                                    <div class="select-report-wrapper" *ngIf="showBalanceSheetReportSelection">
                                        <label class="field-label">
                                            {{ 'aumico_general_information_select_report' | i18next }}
                                            <span class="required">*</span>
                                        </label>

                                        <input
                                            hamSimpleDropDown
                                            data-testid="gi-autofill-balance-report-select"
                                            [options]="balanceSheetReportOptions"
                                            [optionKeys]="['name']"
                                            returnKey="id"
                                            [returnObject]="true"
                                            [formControl]="form.controls['autofillReportForBalance']"
                                            [badgeStyleDropdown]="true"
                                        />
                                    </div>
                                </div>

                                <!-- Income Statement Section -->
                                <div class="section-block income-statement-section">
                                    <div class="section-header">
                                        <h6 class="section-title">
                                            {{ 'aumico_general_information_income_statement' | i18next }}
                                        </h6>
                                    </div>

                                    <app-date-picker-flyout
                                        [formControl]="form.controls['incomePreviousYearFromDate']"
                                        [label]="'aumico_annual_report_general_information_date_from' | i18next"
                                        [required]="true"
                                        [showError]="true"
                                        [errorMessage]="errors.MandatoryFieldError | i18next"
                                        [disabled]="disablePreviousSettings"
                                        flyoutClass="income-previous-from-date-flyout"
                                        (dateSelected)="updateIncomePreviousFromDate($event)"
                                    ></app-date-picker-flyout>

                                    <app-date-picker-flyout
                                        [formControl]="form.controls['incomePreviousYearToDate']"
                                        [label]="'aumico_annual_report_general_information_date_to' | i18next"
                                        [required]="true"
                                        [showError]="true"
                                        [errorMessage]="errors.MandatoryFieldError | i18next"
                                        [disabled]="disablePreviousSettings"
                                        flyoutClass="income-previous-to-date-flyout"
                                        (dateSelected)="updateIncomePreviousToDate($event)"
                                    ></app-date-picker-flyout>

                                    <!-- Toggle for Load previous period data from Aumico -->
                                    <div
                                        class="toggle-wrapper"
                                        data-testid="gi-autofill-income-toggle"
                                        *ngIf="showAutofillFromPreviousForIncomeToggle"
                                    >
                                        <ham-toggle
                                            [formControlValue]="form.controls['autofillFromPreviousForIncome']"
                                            [disabled]="disablePreviousSettings"
                                        >
                                            {{ 'aumico_general_information_load_previous_data_from_aumico' | i18next }}
                                        </ham-toggle>
                                        <span
                                            class="ham-icon period-icon"
                                            hamTooltip="{{
                                                'aumico_general_information_choose_dataset_tooltip_text' | i18next
                                            }}"
                                            [withArrow]="true"
                                            [backGroundHexColor]="'#1F2A37'"
                                            [tooltipClass]="'cpmm-period'"
                                        >
                                            <i class="info-outline-icon"></i>
                                        </span>
                                    </div>

                                    <!-- Select Report Dropdown for Income Statement -->
                                    <div class="select-report-wrapper" *ngIf="showIncomeStatementReportSelection">
                                        <label class="field-label">
                                            {{ 'aumico_general_information_select_report' | i18next }}
                                            <span class="required">*</span>
                                        </label>
                                        <input
                                            hamSimpleDropDown
                                            data-testid="gi-autofill-income-report-select"
                                            [options]="incomeStatementReportOptions"
                                            [optionKeys]="['name']"
                                            returnKey="id"
                                            [returnObject]="true"
                                            [formControl]="form.controls['autofillReportForIncome']"
                                            [badgeStyleDropdown]="true"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>
</div>
<!-- aumico_general_information_autofill_date_popup_content -->
<ham-confirm-decline-modal
    *ngIf="openDialogForAutomaticDueDateChange"
    (cancel)="openDialogForAutomaticDueDateChange = false"
    (action)="onEditDueDateConfirm()"
    footerAlignment="center"
    actionBtnText="{{ 'aumico_general_information_autofill_date_popup_autofill_btn' | i18next }}"
    noActionBtnText="{{ 'aumico_general_information_autofill_date_popup_no_autofill_btn' | i18next }}"
    btnVariant="primary"
>
    <ham-general-confirm-decline-modal-body
        [text]="'aumico_general_information_autofill_date_popup_content' | i18next"
        [icon]="'rocket-icon'"
    ></ham-general-confirm-decline-modal-body>
</ham-confirm-decline-modal>
